import { render, staticRenderFns } from "./IconMediumChance.vue?vue&type=template&id=4c91585f&"
import script from "./IconMediumChance.vue?vue&type=script&lang=ts&"
export * from "./IconMediumChance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports